/** 사용자가 선택할 수 있는 테마 모드. 'system' 은 OS 설정을 따른다. */
export type ThemeMode = 'light' | 'dark' | 'system';

/** 실제 화면에 적용되는 해석된 테마(‘system’ 은 light/dark 중 하나로 환산). */
export type ResolvedTheme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'theme';
